import { render } from "./CategoryFeature.vue?vue&type=template&id=460e44d2&scoped=true"
import script from "./CategoryFeature.vue?vue&type=script&lang=js"
export * from "./CategoryFeature.vue?vue&type=script&lang=js"

import "./CategoryFeature.vue?vue&type=style&index=0&id=460e44d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-460e44d2"]])

export default __exports__